module.exports = __webpack_public_path__ + "media/images/countryrect/sz-478db740c693a685a1bef485ea798887.svg";